import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';
import { required } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, placeholder, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
      placeholder={placeholder}
    />
    {touched &&
      ((error && <span className='alert-danger'>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

  const validate = values => {
    const errors = {};
    if (!values.document_name) {
    errors.document_name = 'Please provide document name.';
    }
    return errors;
  };

let AddHotelDocumentForm = (props) => {
  const { handleSubmit, initialValues, pristine, reset, hasExistingUrlValue, submitting, event, onDrop, files } = props;

  return (
    <div>
      <form onSubmit={handleSubmit} initialValues={initialValues}>
        <FormGroup>
          <Field
            name="document_name"
            component={renderBootstrapField}
            label="Document Name"
            placeholder="Document Name"
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Field type='checkbox' component="input" id="existingUrl" name="document_option" />Use Existing URL &nbsp;
        </FormGroup>

        {hasExistingUrlValue && (<FormGroup>
          <Field
            name="existing_url"
            component={renderBootstrapField}
            label="Provide Existing Url"
            placeholder="Existing Url"
          />
        </FormGroup>)}

        {!hasExistingUrlValue &&(<div>{files}<FormGroup><Dropzone
              ref={(node) => { this.dropzone = node; }}
              onDrop={onDrop}
              
              className="hotel-drop"
              rejectClassName="hotel-drop-reject"
            >
              <div className="hotel-drop-inner">
                <h1>
                  <i className="fa fa-cloud-upload" aria-hidden="true" />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  Drag here or <span className="hotel-drop-click">browse</span> to upload
                </h1>
              </div>
            </Dropzone></FormGroup></div>)}
        
        <FormGroup>
          <ButtonToolbar>
            <Button
              id="hotelDocumentSubmitBtn"
              disabled={pristine || submitting}
              bsStyle="success"
              type="submit"
            >
              <i className="fa fa-pencil fa-lg" />&nbsp;
              Submit
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    </div>
  );
};

AddHotelDocumentForm = reduxForm({
  form: 'addHotelDocumentForm', // a unique identifier for this form
  validate,
})(AddHotelDocumentForm)

// Decorate with connect to read form values
const selector = formValueSelector('addHotelDocumentForm') // <-- same as form name
AddHotelDocumentForm = connect(state => {
  // can select values individually
  const hasExistingUrlValue = selector(state, 'document_option')
  return {
    hasExistingUrlValue
  }
})(AddHotelDocumentForm)

export default AddHotelDocumentForm


// WEBPACK FOOTER //
// src/routes/hotels/components/AddHotelDocumentForm.js